import urlParams from 'libs/query';

// 是否是广告投放的页面
export const isAd = () => Number(urlParams.page_id) > 0 || Number(urlParams.origin_type) === 1;
